module.exports = __webpack_public_path__ + "static/media/orange-jam.6c1b69ac.jpg";